export default __webpack_public_path__ + "static/media/icon-arrow-right.9ec4f1b4.svg";